
<fieldmagic-async-content
  [loading]="fetching$ | async"
>
  <ng-template
    fieldmagicAsyncLoadedContent
  >
    <fieldmagic-page-content-layout
      [label]="! asInput ? headerTitle : null"
      icon="clipboard-list"
    >
      <!-- HEADER -->
      <div
        *ngIf="! asInput"
        class="page-content-header-actions"
      >
        <fieldmagic-page-go-back-button
          [disabled]
          target="list"
          link="checklists"
          [disabled]="(deleting$ | async) || (saving$ | async)"
        >
        </fieldmagic-page-go-back-button>

        <convert-pdf-with-ai-button
          [data]="{
            'checklist_type': type,
            'name': name,
            'mode': 'edit',
            'asset_type_id': assetType | data_get: 'id',
            'specifics': specifics
          }"
          (uploaded)="onGenerate($event)"
          [moduleOrigin]="'checklist'"
          [purpose]="'pdf_checklist_ai'"
        ></convert-pdf-with-ai-button>

        <checklists-generate-with-ai-button
          [data]="{
            'checklist_type': type,
            'name': name,
            'mode': 'edit',
            'asset_type_id': assetType | data_get: 'id',
            'specifics': specifics
          }"
          (generated)="onGenerate($event)"
        ></checklists-generate-with-ai-button>

        <button class="btn-primary btn dropdown-toggle" data-toggle="dropdown" matTooltip="{{ 'actions' | translate }}">
          <fa-icon [icon]="['fas', 'cog']" class="mr-1"></fa-icon>
        </button>
        <div class="dropdown-menu dropdown-content">
          <div class="dropdown-item action-item pointer" (click)="onDuplicate(action, $event)">
            <span>{{ 'duplicate' | translate }}</span>
          </div>
          <div class="dropdown-item action-item pointer" (click)="onConvert(action, $event)">
            <span>{{ 'convert_checklist' | translate }}</span>
          </div>
        </div>

        <fieldmagic-primary-button
          [isInProgress]="deleting$ | async"
          [disabled]="saving$ | async"
          purpose="delete"
          (click)="onDelete()"
          [hasLabel]="false"
          [customClass]="'w30pxi'"
          [iconPosition]="'center'"
        ></fieldmagic-primary-button>

        <fieldmagic-primary-button
          [isInProgress]="saving$ | async"
          [disabled]="saving$ | async"
          purpose="save"
          (click)="onSave()"
          [hasLabel]="false"
          [customClass]="'w30pxi'"
          [iconPosition]="'center'"
        ></fieldmagic-primary-button>
      </div>
      <!-- END HEADER -->

      <!-- CONTENT -->
      <div class="page-content-body">
        <!-- Configurations -->
        <div fieldmagicGridRow class="mb-4">
          <div
            *ngIf="! hideName"
            fieldmagicGridColumn="6"
          >
            <fieldmagic-text-input
              [standalone]="false"
              [(ngModel)]="name"
              label="Name"
              [withRequiredMarker]="true"
              [errors]="errors | data_get: 'name'"
              (change)="onNameChange()"
            >
            </fieldmagic-text-input>
          </div>

          <div
            *ngIf="! hideEnable"
            fieldmagicGridColumn="3"
            class="d-flex align-items-center"
          >
            <fieldmagic-checkbox-input
              [(ngModel)]="isEnabled"
              label="Checklist Enabled"
              (ngModelChange)="onIsEnabledChange()"
            >
            </fieldmagic-checkbox-input>
          </div>

          <div
            fieldmagicGridColumn="3"
            class="d-flex align-items-center"
          >
            <fieldmagic-checkbox-input
              [(ngModel)]="isCommentEnabled"
              label="Enable comment per prompt"
              (ngModelChange)="onIsCommentEnabledChange()"
            ></fieldmagic-checkbox-input>
          </div>
          <div
            fieldmagicGridColumn="3"
          >
            <fieldmagic-number-input
              [(ngModel)]="documentOrdering"
              label="Document Order"
              tooltip="This controls how this checklist will be ordered in the documents. The higher the value the least it will be prioritized."
              [errors]="errors | data_get: 'document_ordering'"
              (ngModelChange)="onDocumentOrderChange()"
              disableScroll
            >
            </fieldmagic-number-input>
          </div>

          <div
            fieldmagicGridColumn="3"
          >
            <fieldmagic-dropdown-input
              *ngIf="type != 'asset'"
              label="Required before"
              [options]="requierdBeforeOptions$ | async"
              [ngModel]="requiredBefore"
              bindValue="id"
              (change)="onRequiredBeforeChange($event)"
              tooltip="Make this checklist required to be completed when performing the given action in the mobile app."
            ></fieldmagic-dropdown-input>
          </div>

          <div
            fieldmagicGridColumn="3"
          >
            <fieldmagic-dropdown-input
              *ngIf="type != 'asset'"
              label="Automatically attached on"
              [options]="attachedOnOptions$ | async"
              [ngModel]="autoAttachedOn"
              bindValue="id"
              tooltip="Make this checklist automatically attached based on a given condition."
              (change)="onAttachedOnChange($event)"
              [grouped]="true"
              [multi]="true"
            ></fieldmagic-dropdown-input>
          </div>
        </div>
        <!-- END configurations -->

        <!-- Actions -->
        <div fieldmagicGridRow class="mb-4">
          <div
            class="d-flex align-items-center"
            fieldmagicGridColumn="6"
          >
            <fieldmagic-text
              purpose="title"
              content="Prompts"
            >
            </fieldmagic-text>
          </div>

          <div
            class="d-flex d-flex-gap justify-content-end"
            fieldmagicGridColumn="6"
          >
            <fieldmagic-primary-button
              variant="link"
              [icon]="[{
                icon: 'plus-circle',
                klass: 'text-success'
              }]"
              (click)="onAddPrompt()"
              tooltip="{{ 'add_prompt' | translate }}"
              matTooltipPosition="above"
              label="Add prompt"
              size="lg"
            >
            </fieldmagic-primary-button>
            <fieldmagic-primary-button
              variant="link"
              [icon]="[{
                icon: 'plus-circle',
                klass: 'text-success'
              }]"
              (click)="onGroupPromptAdd()"
              tooltip="{{ 'add_repeating_group_tooltip' | translate }}"
              matTooltipPosition="above"
              label="Add repeating group"
              size="lg"
            >
            </fieldmagic-primary-button>
          </div>
        </div>
        <!-- END Actions -->

        <!-- Prompts -->
        <div fieldmagicGridRow>
          <div fieldmagicGridColumn="12">
            <table
              class="table table-striped w-100"
            >
              <thead>
                <tr>
                  <th class="theader header-empty"></th>
                  <th class="theader header-prompt">
                    {{ 'prompt' | translate }}
                  </th>
                  <th class="theader header-type">
                    {{ 'type' | translate }}
                  </th>
                  <th class="theader header-value">
                    {{ 'value' | translate }}
                  </th>
                  <th class="theader header-icons">
                    <fieldmagic-icon
                      position="center"
                      icon="asterisk"
                      class="text-danger"
                      tooltip="{{ 'tooltip_required' | translate }}"
                    >
                    </fieldmagic-icon>
                  </th>
                  <th class="theader header-icons">
                    <fieldmagic-icon
                      position="center"
                      icon="desktop"
                      tooltip="{{ 'tooltip_report_visibility' | translate }}"
                    ></fieldmagic-icon>
                  </th>
                  <th class="theader header-icons">
                    <fieldmagic-icon
                      position="center"
                      icon="file-image"
                      tooltip="{{ 'add_image_to_prompt' | translate }}"
                    ></fieldmagic-icon>
                  </th>
                  <th class="theader header-icons">
                    <fieldmagic-icon
                      position="center"
                      icon="file-image"
                      tooltip="Require atleast 1 image to the prompt"
                      [withRequiredMarker]="true"
                    ></fieldmagic-icon>
                  </th>
                  <th class="theader header-prompt-actions"></th>
                </tr>
              </thead>

              <tbody
                *ngIf="prompts$ | async as prompts"
                class="prompt-container outer"
                [cdkDropListEnterPredicate]="isDroppable"
                [cdkDropListConnectedTo]="getRepeatingGroupsClassNames(prompts)"
                (cdkDropListDropped)="onPromptDragDropped($event, {
                  prompts: prompts
                })"
                cdkDropList
              >
                <ng-container *ngIf="prompts | filled; else noPrompts;">
                  <ng-container *ngFor="let prompt of prompts; index as prompt_index; trackBy: tracker">
                    <tr
                      *ngIf="! prompt.is_group"
                      class="prompt-row"
                      app-checklist-prompt
                      [index]="prompt_index"
                      [prompt]="prompt"
                      (removed)="onPromptRemove($event, prompts)"
                      [cdkDragData]="prompt"
                      cdkDrag
                      [fieldEntries]="fieldEntries$ | async"
                      [assetType]="assetType"
                      [forType]="type"
                      [errors]="errors"
                      [scheduleTypes]="availablePeriods"
                      (edited)="onPromptsChange()"
                    >
                      <td class="text-center">
                        <div class="d-flex d-flex-gap">
                          <fieldmagic-icon
                            purpose="dragging"
                            icon="grip-vertical"
                            tooltip="{{ 'drag_to_change_position' | translate }}"
                            cdkDragHandle
                            position="center"
                          ></fieldmagic-icon>

                          <ng-container
                            *ngIf="((prompt | data_get: 'type') === 'pass/fail')"
                            [ngTemplateOutlet]="addDefectButton"
                            [ngTemplateOutletContext]="{
                              prompt: prompt
                            }"
                          ></ng-container>
                        </div>
                      </td>
                    </tr>
                    <tr
                      *ngIf="prompt.is_group"
                      class="prompt-row"
                      [cdkDragData]="prompt"
                      (mouseout)="onHover(true)"
                      (mouseover)="onHover(false)"
                      cdkDrag
                    >
                      <td
                        class="p-0"
                        [attr.colspan]="(type == 'asset') ? 10 : 9"
                      >
                        <table
                          class="w-100 group-prompt-background rounded-top"
                        >
                          <tbody
                            id="repeating-group-{{ prompt_index }}-header"
                            [cdkDropListConnectedTo]="getConnectedDroppableLists(prompt_index, prompts)"
                            (cdkDropListDropped)="onPromptDragDropped($event, {
                              prompts: prompts,
                              group: prompt
                            })"
                            cdkDropList
                          >
                            <tr class="group-name-row">
                              <td
                                class="border-top-0 header-icons"
                              >
                                <fieldmagic-icon
                                  purpose="dragging"
                                  icon="grip-vertical"
                                  class="text-white"
                                  position="center"
                                  cdkDragHandle
                                  tooltip="{{ 'drag_to_change_position' | translate }}"
                                ></fieldmagic-icon>
                              </td>
                              <td
                                class="text-center border-top-0 pl-0 pr-0 pb-4 pt-4"
                                [attr.colspan]="(type == 'asset') ? 10 : 9"
                              >
                                <div class="d-flex align-items-center d-flex-gap-2x">
                                  <fieldmagic-text-input
                                    class="w-50"
                                    placeholder="Group name"
                                    [(ngModel)]="prompt.group_name"
                                    [errors]="errors | data_get: ('%s:prompt' | sprintf: [prompt.id])"
                                    (change)="onGroupChange(prompt, prompt_index)"
                                  >
                                  </fieldmagic-text-input>
                                  <div
                                    *ngIf="type == 'asset'"
                                    class="w-30 d-flex d-flex-gap-2x align-items-center text-left"
                                  >
                                    <fieldmagic-interval-input
                                      [(ngModel)]="prompt.available_period"
                                      [standalone]="true"
                                      class="w-100"
                                      (change)="onGroupChange(prompt, prompt_index)"
                                      [withAlways]="true"
                                    ></fieldmagic-interval-input>
                                  </div>

                                  <fieldmagic-primary-button
                                    purpose="icon"
                                    [icon]="[{
                                      icon: 'ellipsis-h',
                                      klass: 'text-white'
                                    }]"
                                    tooltip="More group confguration"
                                    (click)="onOpenPerGroupPromptConfiguration(prompt)"
                                  ></fieldmagic-primary-button>
                                  <fieldmagic-primary-button
                                      purpose="icon"
                                      iconSize="lg"
                                      [icon]="[
                                      {
                                        icon: 'plus-circle',
                                        klass: 'text-success',
                                        size: 'sm'
                                      },
                                      {
                                        icon: 'circle',
                                        klass: 'text-white',
                                        size: 'sm'
                                      }
                                    ]"
                                    (click)="onAddPrompt({
                                      prompts: prompts,
                                      group: prompt
                                    })"
                                    tooltip="{{ 'add_prompt_under_group' | translate }}"
                                  ></fieldmagic-primary-button>
                                </div>
                              </td>
                              <td
                                class="border-top-0 pr-4"
                              >
                                <div class="d-flex justify-content-end">
                                  <fieldmagic-primary-button
                                    purpose="delete-icon"
                                    (click)="onPromptRemove(prompt_index, prompts)"
                                  >
                                  </fieldmagic-primary-button>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          class="table table-striped mb-0 group-prompt-border"
                        >
                          <tbody
                            id="repeating-group-{{ prompt_index }}"
                            class="prompt-container"
                            [cdkDropListConnectedTo]="getConnectedDroppableLists(prompt_index, prompts)"
                            (cdkDropListDropped)="onPromptDragDropped($event, {
                              prompts: prompts,
                              group: prompt
                            })"
                            cdkDropList
                          >
                            <ng-container *ngFor="let sub_prompt of prompt.prompts; index as sub_index; trackBy: tracker">
                              <tr
                                app-checklist-prompt
                                cdkDrag
                                class="prompt-row"
                                [parent]="prompt"
                                [prompt]="sub_prompt"
                                [index]="sub_index"
                                [parentIndex]="prompt_index"
                                [cdkDragData]="sub_prompt"
                                [fieldEntries]="fieldEntries$ | async"
                                (removed)="onPromptRemove(sub_index, prompts, {
                                  group: prompt
                                })"
                                [assetType]="assetType"
                                [availableOnPeriod]="prompt | data_get: 'available_period'"
                                [forType]="type"
                                [errors]="errors"
                                [scheduleTypes]="availablePeriods"
                                (edited)="onPromptsChange()"
                              >
                                <td
                                  class="indent-and-drag-asset"
                                >
                                  <div class="d-flex d-flex-gap">
                                    <fieldmagic-icon
                                      purpose="dragging"
                                      icon="grip-vertical"
                                      cdkDragHandle
                                      tooltip="{{ 'drag_to_change_position' | translate }}"
                                    ></fieldmagic-icon>

                                    <ng-container
                                      *ngIf="((sub_prompt | data_get: 'type') === 'pass/fail')"
                                      [ngTemplateOutlet]="addDefectButton"
                                      [ngTemplateOutletContext]="{
                                        prompt: sub_prompt
                                      }"
                                    ></ng-container>
                                  </div>
                                </td>
                              </tr>

                              <ng-container
                                *ngIf="((sub_prompt | data_get: 'type') === 'pass/fail')"
                                [ngTemplateOutlet]="promptDefects"
                                [ngTemplateOutletContext]="{
                                  prompt: sub_prompt
                                }"
                              ></ng-container>
                            </ng-container>
                          </tbody>
                        </table>
                      </td>
                    </tr>

                    <ng-container
                      *ngIf="! prompt.is_group && ((prompt | data_get: 'type') === 'pass/fail')"
                      [ngTemplateOutlet]="promptDefects"
                      [ngTemplateOutletContext]="{
                        prompt: prompt
                      }"
                    ></ng-container>
                  </ng-container>
                </ng-container>
                <ng-template #noPrompts>
                  <tr class="text-center">
                    <td
                      [attr.colspan]="(type == 'asset') ? 10 : 9"
                    >
                      {{ 'No prompts' | translate }}
                    </td>
                  </tr>
                </ng-template>
              </tbody>
            </table>
          </div>
        </div>
        <!--End Prompts-->
      </div>
      <!-- END CONTENT -->
    </fieldmagic-page-content-layout>
  </ng-template>
</fieldmagic-async-content>

<ng-template
  #addDefectButton
  let-prompt="prompt"
>
  <ng-container *ngIf="possibilities$ | async as possibilities">
    <fieldmagic-icon
      *ngIf="((prompt | data_get: 'type') === 'pass/fail') && possibilities | filled"
      purpose="clicking"
      [icon]="[{
        icon: (prompt | data_get:'has_faults') ? 'minus-circle' : 'plus-circle',
        klass: (prompt | data_get:'has_faults') ? 'text-danger' : 'text-success'
      }]"
      [tooltip]="(prompt | data_get:'has_faults')
        ? 'Click to remove default defects'
        : 'Click to add default defects'"
      position="center"
      (click)="(prompt.has_faults) ? onRemovePromptFault(prompt) : onAddPromptFault(prompt)"
    >
    </fieldmagic-icon>
  </ng-container>
</ng-template>

<ng-template
  #promptDefects
  let-prompt="prompt"
>
  <tr *ngIf="(prompt | data_get: 'type') === 'pass/fail' && (prompt | data_get: 'has_faults')">
    <td class="indent-and-drag-asset" style="padding-right: 0px">
      <div class="bg-indent float-right"></div>
    </td>
    <td colspan="9">
      <fieldmagic-dropdown-input
        [(ngModel)]="prompt.faults"
        placeholder="Please select a possible defect.."
        [options]="possibilities$ | async"
        (ngModelChange)="onPromptFaultChange($event, prompt)"
        [grouped]="true"
        [multi]="true"
        bindValue="id"
      >
        <ng-template
          fieldmagicDropdownOptionGroupTmp
          let-item="item"
        >
          <div
            class="w-100 p-2"
            [style.background]="item | data_get: 'first.color'"
          >
            <span
              [style.color]="item | data_get: 'first.color' | bg_text_color"
            >
              {{ item.text | translate }}
            </span>
          </div>
        </ng-template>
      </fieldmagic-dropdown-input>
    </td>
  </tr>
</ng-template>